import { defineMessages } from 'react-intl';

export const sortFilterBarMessages = defineMessages({
  reviewContent: {
    id: 'pd.sortFilterBar.reviewContent',
    defaultMessage: 'Obsah recenze',
  },

  productVariant: {
    id: 'pd.sortFilterBar.productVariant',
    defaultMessage: 'Varianta produktu',
  },
  reviewCountry: {
    id: 'pd.sortFilterBar.reviewCountry',
    defaultMessage: 'Recenze dle země',
  },
  rating: { id: 'pd.sortFilterBar.rating', defaultMessage: 'Hodnocení' },
  apply: { id: 'pd.sortFilterBar.apply', defaultMessage: 'Filtrovat' },

  contentTypeVerified: {
    id: 'pd.sortFilterBar.contentTypeVerified',
    defaultMessage: 'Ověřené recenze',
  },
  contentTypeWithText: {
    id: 'pd.sortFilterBar.contentTypeWithText',
    defaultMessage: 'Textové recenze',
  },
  contentTypeWithImages: {
    id: 'pd.sortFilterBar.contentTypeWithImages',
    defaultMessage: 'Obrázkové recenze',
  },

  sortByLabel: {
    id: 'pd.sortFilterBar.sortByLabel',
    defaultMessage: 'Seřadit podle',
  },

  displayedRangeDesktop: {
    id: 'pd.sortFilterBar.displayedRange.desktop',
    defaultMessage: 'Zobrazeno {from}–{to} z {total} ',
  },
  displayedRangeMobile: {
    id: 'pd.sortFilterBar.displayedRange.mobile',
    defaultMessage: '{from}–{to} z {total} ',
  },
});
